import CountDown from '@/components/CountDown';
import PageLayout from '@/components/PageLayout';
import Button from '@/components/UI/Button';
import Checkbox from '@/components/UI/Checkbox';
import Image from '@/components/UI/Image';
import Input from '@/components/UI/Input';
import { ENGLISH_LANG, i18nMap, newVersionRegion, rpcMap } from '@/constants';
import { loginImageMap } from '@/constants/login';
import { createSubscribe, getVerifyCode, sendActivationEmail, toLogin } from '@/service';
import { getKaamelPlan } from '@/utils/kaamelTest';
import { useGlobal } from '@/utils/useGlobal';
import { Form } from 'antd';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import debounce from 'lodash/debounce';
import cookie from 'react-cookies';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './register.module.scss';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
const HOMEBATTERY_REDIRECT = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;

export default function Register({ redirect, prevPath, lang }: any) {
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const { useState, useRouter, useRef, useLang, Link, useEffect } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('registeremail');
    const [inputClass, SetInputClass] = useState({
        activeFirst: '',
        activeSecond: '',
        activeThird: '',
        name: '',
    });
    const [loading, setLoading] = useState(false);
    const recaptchaRef = useRef();
    const [allValidate, setAllValidate] = useState({ email: false, pwd: false, confirmPwd: false });
    const [step, setStep] = useState({ first: true, second: false, third: false });
    const [isShowTip, setIsShowTip] = useState(false);
    const [emailValidating, setEmailValidating] = useState(''); // 'success' 'warning' 'error' 'validating'
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [kaamelInfo, setKaamelInfo] = useState(null);
    const router = new useRouter();
    const { locale, query } = router;
    const outerUserInfo = cookie.load('outerUserInfo');
    const form = Form.useForm()[0];
    const emailCodeForm = Form.useForm()[0];
    const [emailCodeInputStatus, setEmailCodeInputStatus] = useState(0);
    const [resendCode, setResendCode] = useState(60);
    const [formData, setFormData] = useState({});
    const isNewVersionRegion = newVersionRegion(locale);
    const [humanCheck, setHumanCheck] = useState(false);
    const loginImageUrl = loginImageMap[locale as keyof typeof loginImageMap] || loginImageMap.us;
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };

    // 校验邮箱
    const validateEmail = () => {
        return {
            validator: async (_: any, value: any) => {
                const regx = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                if (!value) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(lang.site_login_tip_email_empty);
                }

                if (!regx.test(value)) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(lang.site_login_tip_email_format_incorrect);
                }

                setAllValidate({
                    ...allValidate,
                    ...{ email: true },
                });

                return Promise.resolve();
            },
        };
    };

    // 校验密码
    const validatePassword = () => {
        return {
            validator(_: any, value: any) {
                const regx = isNewVersionRegion
                    ? /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-])\S{15,32}$/
                    : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ pwd: false },
                    });
                    return Promise.reject(t('logintips.site_login_tip_password_empty'));
                }
                if (!value || regx.test(value)) {
                    setAllValidate({
                        ...allValidate,
                        ...{ pwd: true },
                    });
                    return Promise.resolve();
                }
                setAllValidate({
                    ...allValidate,
                    ...{ pwd: false },
                });
                return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
            },
        };
    };

    // 校验确认密码
    const validateConfirmPassword = ({ getFieldValue }: any) => {
        return {
            validator(_: any, value: any) {
                const pwd = getFieldValue('password');
                setIsErrorTip(false);
                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ confirmPassword: false },
                    });
                    return Promise.reject(lang.site_login_tip_password_empty);
                }
                if (pwd !== value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ confirmPassword: false },
                    });
                    return Promise.reject(lang.site_login_tip_password_twice_inconsistent);
                }
                setAllValidate({
                    ...allValidate,
                    ...{ confirmPassword: true },
                });
                return Promise.resolve();
            },
        };
    };

    // 提交
    const onFinish = async (values: any) => {
        const recaptchaRes = humanCheck ? { recaptchaResponse } : {};
        const { inviteCode2 } = query;

        let params: any = {
            source: 'ECOFLOW_WEB',
            userType: outerUserInfo?.data?.data?.userType, //用户类型
            scene: outerUserInfo?.data?.data?.scene, //登陆场景
            oauth: outerUserInfo?.data?.data?.oauth || {},
            password: Base64.stringify(Utf8.parse(formData?.password)),
            ...recaptchaRes,
        };

        // 家储官网注册用户
        if (redirect && redirect.includes(`${HOMEBATTERY_REDIRECT}`)) {
            params.efHomeBattery = true;
        }
        if (isNewVersionRegion) {
            Object.assign(params.oauth, { code: values?.code });
        }
        if (inviteCode2) {
            Object.assign(params, { inviteCode2 });
        }
        params =
            outerUserInfo?.validateType === 'email'
                ? Object.assign({}, params, { email: formData?.email })
                : Object.assign({}, params, { phone: formData?.email });
        setLoading(true);
        const lang2 = lang;
        try {
            const res: any = await toLogin(params, locale);
            let lang = '';

            if (locale && ENGLISH_LANG.includes(locale)) {
                lang = 'en_US';
            } else if (locale && locale === 'cn') {
                lang = 'zh_CN';
            }
            setLoading(false); // 关闭loading
            if (res.code === '0') {
                const data = lang ? { lang } : {};
                Object.assign(data, { email: formData.email, scene: 'ACCOUNT_VERIFICATION' });
                sendActivationEmail(data, locale);
                // 如果是us站或者ca，直接订阅不需要勾选，其他站点则需要
                if (locale === 'us' || locale === 'ca' || formData.subscribe) {
                    createSubscribe({
                        email: formData.email,
                        source: 'WEB_REGISTER',
                        eventTracking: subscribeCookie({
                            entry_name: lang2?.site_register_register,
                        }),
                    });
                }
                if (isNewVersionRegion) {
                    setRecaptchaResponse('');
                    const rptRef: any = recaptchaRef?.current;
                    rptRef?.reset && rptRef?.reset();
                    setFormData({});
                }
                cookie.remove('outerUserInfo');
                setStep({ first: false, second: false, third: true });
            } else {
                if (!isNewVersionRegion) {
                    setRecaptchaResponse('');
                    const rptRef: any = recaptchaRef?.current;
                    rptRef?.reset && rptRef?.reset();
                }
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
        } catch (e) {
            setLoading(false); // 关闭loading
            console.log('e', e);
        }
    };

    const goLogin = (text: string) => {
        signupCookie({ entry_name: text });
        router.push(`/${locale}/login?${query.redirect ? `redirect=${encodeURIComponent(query.redirect)}` : ''}`);
    };

    const onBlurInput = (event: any, value: any) => {
        if (value === 'pwd') {
            setIsShowTip(false);
        }
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: '',
                    activeSecond: inputClass.activeSecond,
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: '',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: '',
                    name: value,
                });
            }
        }
    };

    const onFocusInput = (event: any, value: any) => {
        if (value === 'pwd') {
            const [infos] = form.getFieldsError(['password']);
            const { errors } = infos;

            if (!errors.length) {
                setIsShowTip(true);
            }
        }
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: 'active',
                    activeSecond: inputClass.activeSecond,
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: 'active',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: 'active',
                    name: value,
                });
            }
        }
    };

    // 发送邮件验证码
    const sendEmailCode = async () => {
        const account = form.getFieldValue('email');
        const recaptchaRes = humanCheck ? { recaptchaResponse } : {};
        const obj = { scene: 'WEBSITE_REGISTER_VERIFICATION_CODE', account, ...recaptchaRes };
        setLoading(true);
        try {
            const res: any = await getVerifyCode(obj, locale);
            setLoading(false);
            if (res.code === '0') {
                setStep({ first: false, second: true, third: false });
            } else if (res.code === '2017') {
                setHumanCheck(true);
                setIsErrorTip(true);
                setErrorTip(res.message);
            } else {
                setIsErrorTip(true);
                setErrorTip(res.message);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        const info = getKaamelPlan();
        setKaamelInfo(info);
    }, []);

    return (
        <PageLayout style={{ background: '#f8f8f8' }}>
            <div className={`${css.register} container`}>
                {/* {lang.title} */}
                <div className="login-box login_page_a">
                    <div className="left">
                        <Image src={loginImageUrl} width={509} height={850} alt={lang.site_register_register}></Image>
                    </div>
                    <div className={`right ${step.third ? 'third-right' : ''}`}>
                        {step.first && (
                            <div className="register-box">
                                <h2>{lang.site_register_register}</h2>
                                <p className="register-sub-title">{lang.site_register_subtitle}</p>
                                <Form name="normal_login" className="login-form" form={form} initialValues={{ remember: false }}>
                                    <div className="inputItem">
                                        <label className={inputClass.activeFirst == 'active' ? 'active' : ''}>{lang.site_login_email}</label>
                                        <Form.Item name="email" validateStatus={emailValidating} rules={[validateEmail]} validateTrigger="onBlur">
                                            <Input
                                                className="default-input "
                                                autoComplete="off"
                                                aria-label={lang.site_login_email}
                                                onFocus={(e: any) => onFocusInput(e, 'email')}
                                                onBlur={(e: any) => onBlurInput(e, 'email')}
                                                onChange={debounce(() => {
                                                    if (!inputClass.activeFirst) {
                                                        SetInputClass({
                                                            activeFirst: 'active',
                                                            activeSecond: inputClass.activeSecond,
                                                            activeThird: inputClass.activeThird,
                                                            name: 'email',
                                                        });
                                                        form.validateFields(['Email']);
                                                    }
                                                }, 300)}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div className="inputItem">
                                        <label className={inputClass.activeSecond == 'active' ? 'active' : ''}>{lang.site_login_password}</label>
                                        <Form.Item name="password" rules={[validatePassword]} validateTrigger="onBlur">
                                            <Input.Password
                                                type="password"
                                                className="default-input"
                                                autoComplete="new-password"
                                                aria-label={lang.site_login_password}
                                                iconRender={(visible: boolean) => (
                                                    <div>
                                                        <i className={`iconfont ${visible ? 'icon-eye-in' : 'icon-eye-out'}`}></i>
                                                    </div>
                                                )}
                                                onFocus={(e: any) => onFocusInput(e, 'pwd')}
                                                onBlur={(e: any) => onBlurInput(e, 'pwd')}
                                            />
                                        </Form.Item>
                                        {isShowTip && (
                                            <div className="password-tip">
                                                <div className="header-line">
                                                    <span>Example</span>
                                                    <span>Chage123#4</span>
                                                </div>
                                                <div className="password-tip-content">{t('logintips.site_login_tip_password_format_wrong')}</div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="inputItem">
                                        <label className={inputClass.activeThird == 'active' ? 'active' : ''}>{lang.site_register_enter_password_again}</label>
                                        <Form.Item
                                            name="confirmPassword"
                                            dependencies={['password']}
                                            rules={[validateConfirmPassword]}
                                            validateTrigger="onBlur"
                                        >
                                            <Input.Password
                                                type="password"
                                                className="default-input"
                                                autoComplete="new-password"
                                                aria-label={lang.site_register_enter_password_again}
                                                iconRender={(visible: boolean) => (
                                                    <div>
                                                        <i className={`iconfont ${visible ? 'icon-eye-in' : 'icon-eye-out'}`}></i>
                                                    </div>
                                                )}
                                                onFocus={(e: any) => onFocusInput(e, 'conpwd')}
                                                onBlur={(e: any) => onBlurInput(e, 'conpwd')}
                                            />
                                        </Form.Item>
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>
                                    {humanCheck && isNewVersionRegion && (
                                        <Form.Item
                                            name="recaptchaResponse"
                                            rules={[
                                                {
                                                    validator() {
                                                        if (recaptchaResponse) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                    },
                                                },
                                            ]}
                                            style={{ marginBottom: '32px', marginTop: '45px' }}
                                        >
                                            <div className="g-recaptcha">
                                                {/* @ts-ignore */}
                                                <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                            </div>
                                        </Form.Item>
                                    )}
                                    <Form.Item style={{ marginBottom: '16px' }}>
                                        <Form.Item
                                            name="remember"
                                            valuePropName="checked"
                                            rules={[
                                                {
                                                    validator: (_, value) =>
                                                        value ? Promise.resolve() : Promise.reject(new Error(lang.site_login_tip_agree_user_agreement)),
                                                },
                                            ]}
                                            noStyle
                                        >
                                            <Checkbox className="agreement">
                                                {t.rich('logintips.site_login_tip_agree_user_agreement', {
                                                    link1: (children: any) => (
                                                        <Link
                                                            href={
                                                                locale === 'cis'
                                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/PrivacyPolicy.html'
                                                                    : locale === 'uk' && kaamelInfo?.privacyUrl
                                                                    ? kaamelInfo?.privacyUrl
                                                                    : `https://account.ecoflow.com/agreement/${
                                                                          i18nMap[locale] || i18nMap.us
                                                                      }/PrivacyPolicy.html`
                                                            }
                                                            newWin
                                                            ariaLabel={s('privacy')}
                                                        >
                                                            {children}
                                                        </Link>
                                                    ),
                                                    link2: (children: any) => (
                                                        <Link
                                                            href={
                                                                locale === 'cis'
                                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/TermsOfUse.html'
                                                                    : `https://account.ecoflow.com/agreement/${i18nMap[locale] || i18nMap.us}/TermsOfUse.html`
                                                            }
                                                            newWin
                                                            ariaLabel={s('TOU')}
                                                        >
                                                            {children}
                                                        </Link>
                                                    ),
                                                })}
                                            </Checkbox>
                                        </Form.Item>
                                    </Form.Item>
                                    {locale !== 'us' && locale !== 'ca' && (
                                        <Form.Item name="subscribe" valuePropName="checked" noStyle>
                                            <Checkbox className="agreement subscribe">{lang.site_register_agree_subscribe}</Checkbox>
                                        </Form.Item>
                                    )}
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            className="black-btn large register-form-submit"
                                            loading={loading}
                                            aria-label={lang.site_register_submit}
                                            disabled={!(allValidate.email && allValidate.pwd && allValidate.confirmPassword)}
                                            onClick={async () => {
                                                setFormData(form.getFieldsValue());
                                                if (isNewVersionRegion) {
                                                    sendEmailCode();
                                                    setIsErrorTip(false);
                                                    setErrorTip('');
                                                } else {
                                                    await onFinish({});
                                                }
                                            }}
                                        >
                                            {lang.site_register_next}
                                        </Button>
                                        <Button
                                            type="link"
                                            className="large login-form-button"
                                            aria-label={lang.site_login_login}
                                            onClick={() => goLogin(lang.site_sign_instead)}
                                        >
                                            {lang.site_sign_instead}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        )}
                        {step.second && (
                            <div className="register-box box-center second-box">
                                <h1 className="second-title">{lang.site_register_second_title}</h1>
                                <h3 className="second-desc">
                                    {s.rich('site_register_second_desc', {
                                        a: () => (
                                            <a style={{ color: '#3370ff', textDecoration: 'underline' }} href={`mailto:${formData.email}`}>
                                                {formData.email}
                                            </a>
                                        ),
                                    })}
                                </h3>
                                <Form name="code_form" className="login-form" form={emailCodeForm} initialValues={{ remember: false }} onFinish={onFinish}>
                                    <div className="inputItem">
                                        <label className={emailCodeInputStatus !== 0 ? 'active' : ''}>{lang.site_register_enter_code}</label>
                                        <Form.Item name="code" shouldUpdate>
                                            <Input
                                                className="default-input "
                                                autoComplete="off"
                                                aria-label={lang.site_register_enter_code}
                                                onFocus={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                }}
                                                onBlur={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 0);
                                                }}
                                                onChange={debounce((e) => {
                                                    setErrorTip('');
                                                    setIsErrorTip(false);
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                }, 300)}
                                            />
                                        </Form.Item>
                                        <div className="error-tip">{errorTip}</div>
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn large register-form-submit"
                                            loading={loading}
                                            aria-label={lang.site_register_submit}
                                            disabled={emailCodeInputStatus !== 2}
                                        >
                                            {lang.site_register_submit}
                                        </Button>
                                    </Form.Item>
                                </Form>
                                <Button
                                    type="link"
                                    disabled={resendCode !== 0}
                                    className="resend-code"
                                    onClick={() => {
                                        sendEmailCode();
                                        setResendCode(60);
                                    }}
                                >
                                    {lang.site_resend_code}
                                    <CountDown
                                        sec={resendCode}
                                        onFinish={() => {
                                            setResendCode(0);
                                        }}
                                    />
                                </Button>
                            </div>
                        )}
                        {step.third && (
                            <div className="register-box box-center">
                                <p>{lang.site_register_successful}</p>
                                <Button
                                    type="primary"
                                    className="black-btn large login-redirect-button"
                                    aria-label={lang.site_register_got_it}
                                    onClick={() => goLogin(lang.site_register_got_it)}
                                >
                                    {lang.site_register_got_it}
                                </Button>
                                <div className="redirect-tip-box">
                                    {s.rich('redirect_tip', {
                                        highLight: (text: string) => (
                                            <span>
                                                {text}
                                                <CountDown
                                                    sec={3}
                                                    onFinish={() => {
                                                        goLogin(text);
                                                    }}
                                                />
                                            </span>
                                        ),
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const prevPath = context.req.headers.referer;
    const { redirect } = context.query;

    return {
        props: {
            redirect: redirect || '',
            prevPath: prevPath || '',
        },
    };
}
